module.exports = __webpack_public_path__ + "static/img/success.ad8c7ab3.png";